import { render, staticRenderFns } from "./MyProfileCard.vue?vue&type=template&id=0a58dda5&scoped=true&"
import script from "./MyProfileCard.vue?vue&type=script&lang=js&"
export * from "./MyProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileCard.vue?vue&type=style&index=0&id=0a58dda5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58dda5",
  null
  
)

component.options.__file = "MyProfileCard.vue"
export default component.exports